import { Component, OnInit } from '@angular/core';
import { TipsService } from 'src/app/services/tips.service';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { CONSTANTS } from 'src/app/shared/constants';
import { LoadingAkanaService } from 'src/app/services/loading-akana.service';
import { trigger, style, animate, transition } from '@angular/animations';

declare var $: any;
declare var document;

@Component({
  standalone: false,
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss'],
  animations: [
    trigger('fadeT', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class TipsComponent implements OnInit {
  list: string[];
  swipe: any;
  show: boolean;
  item: any;
  mainTip: boolean;
  showLoading = false;

  constructor(private readonly tipsService: TipsService, private readonly route: Router, private readonly c: CommonsService, private l: LoadingAkanaService) { }

  ngOnInit() {
    this.showLoadingMethod(true);
    this.tipsView();
    this.c.firstChargePage('Consejos', 'Consejos financieros', 'content');
    this.c.eventsAnalitics('visit screen', 'Consejos financieros', 'Tips');
  }

  tipsView = () => {
    this.tipsService.getTips(sessionStorage.getItem('t')).subscribe(data => {
      setTimeout(() => {
        this.showLoadingMethod(false);
      }, CONSTANTS.timeLoading);
      if (data.Code === 401) {
        this.c.openModalSession();
      } else {
        this.saveData(data);
      }
    }, error => {
      if (error) {
        this.c.openModalSession();
      }
    });
  }

  getSubString(e: string) {
    return e.substr(0, 75);
  }

  saveData = (data?: any) => {
    if (data.Messages.length) {
      data.Messages.map((d, i) => {
        const c = CONSTANTS.categories.filter(i => i.id === d.IdCategory)[0];
        if (c) {
          d.name = c.name;
        }
        if (i === 0) {
          this.item = d;
          this.mainTip = true;
        }
      });
      sessionStorage.setItem('_tips', JSON.stringify(data));
      this.list = data.Messages;
      this.showTips();
      this.show = false;
    } else {
      this.show = true;
    }
  }

  selectedItem = (data) => {
    this.item = data;
  }

  showTips = () => {
    setTimeout(() => {
      $('#autoWidth').lightSlider({
        autoWidth: true,
        item: 4,
        loop: false,
        slideMargin: 30,
        onSliderLoad: () => {
          $('#autoWidth').removeClass('cs-hidden');
        }
      });
      document.getElementsByClassName('lSPager')[0].style.display = 'none';
    }, 0);
  }

  /**
   * muestra o esconde el modal
   */
  private showLoadingMethod = (value: boolean) => {
    this.showLoading = value;
    if (!value) {
      document.querySelector('body').style.overflow = '';
    }
  }
}
